import {
  MerchantSetupProductSchema,
  MerchantSetupProgressSchema,
} from "@redotech/redo-onboarding-db-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const startMerchantSetupProgress = {
  name: "startMerchantSetupProgress" as const,
  input: z.object({
    product: MerchantSetupProductSchema,
    entrySource: z.string().nullish(),
    resetDismissed: z.boolean().optional(),
    resetIntake: z.boolean().optional(),
    resetDeferred: z.boolean().optional(),
  }),
  output: zExt.filterToValid(MerchantSetupProgressSchema),
};
